import React, { useMemo } from 'react'
import LiveBetsFeedPage from './modules/LiveBetsFeedPage'
import LiveBettingInsightsPage from './modules/LiveBettingInsightsPage'
import LiveBettingAutomationPage from './modules/LiveBettingAutomationPage'

const tabs = [
  {
    id: 'live-feed',
    label: 'Live feed',
    description: 'Monitor live vouchers and exposures in one place',
    component: LiveBetsFeedPage,
  },
  {
    id: 'insights',
    label: 'Single Analytics',
    description: 'Analyze your single bet performance over time',
    component: LiveBettingInsightsPage,
  },
  {
    id: 'automation',
    label: 'Automation Parlays',
    description: 'Automate your parlay betting strategies',
    component: LiveBettingAutomationPage,
  },
]

const LiveBettingControl = () => {
  //const [activeTab, setActiveTab] = useState(tabs[0]);
  const activeTab = tabs[0];
  const ActiveComponent = useMemo(() => activeTab.component, [activeTab])

//rounded-2xl

  return (
    <div className="flex min-h-full flex-col gap-4 p-2 lg:p-4">
      {/* <header className="rounded-xl border border-customAccentBlue/20 bg-white p-4 shadow-lg shadow-customAccentBlue/20 dark:shadow-customAccent/20 dark:border-customSurface dark:bg-customSurface">
        <nav className="flex flex-wrap gap-2">
          {tabs.map((tab) => {
            const isActive = tab.id === activeTab.id
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab)}
                className={`group flex min-w-[190px] flex-col gap-1 rounded-xl border px-4 py-3 text-left transition 
                  ${isActive ? 'border-transparent dark:bg-customAccent bg-customAccentBlue text-white shadow-lg shadow-customAccentBlue/40 dark:shadow-customAccent/40' 
                  : 'border-customAccentBlue/20 dark:border-customAccent/20 bg-white text-customPrimaryText hover:border-customAccentBlue/40 dark:hover:border-customAccent/40 hover:bg-customAccentBlue/5 dark:hover:bg-customAccent/5 dark:bg-customSurfaceMuted dark:text-customHeading'}`}
              >
                <span className="text-sm font-semibold">{tab.label}</span>
                <span
                  className={`text-xs ${isActive ? 'text-white/80' : 'text-customSecondaryText dark:text-customMuted'}`}
                >
                  {tab.description}
                </span>
              </button>
            )
          })}
        </nav>
      </header> */}
      <section className="min-h-[60vh]">
        <ActiveComponent />
      </section>
    </div>
  )
}

export default LiveBettingControl

